import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import SeleccionInformesScreen from './screen';
import { ServerErrorMessage } from '../../../../../../shared/utils/error';
import { useNotifications} from '../../../../../../shared/hooks/Notifications';
import { InformesDetalleAdapter } from '../../../../../../infraestructure/persistence/rest/InformesDetalleAdapter';

import { downloadFile } from '../../../../../../shared/utils/download';

export const SeleccionInformesContainer = () => {

	const api = new InformesDetalleAdapter();
	const {resultError, exceptionError, launchNotification} = useNotifications();
	
	let [ data, setData ] = useState<any>([]);
	let [isLoading, setIsLoading] = useState<boolean>(false);

	let result: any;

	const DescargarInforme = async (data: any) => {
		setIsLoading(true);
		try {
			result = await api.DescargarInforme(data);
			if(result.data && result.data!=="")
			{
				downloadFile(result.data, data.IdTipoInforme + '_' + data.IdTipo + '_' + data.año + '_' + data.periodo + '.xlsx');
			}else{resultError();}
		} catch (e) {
			let exception = ServerErrorMessage(e);
			exceptionError(exception)
		}
		setIsLoading(false);
  	};

	return (
		<>
			<SeleccionInformesScreen data={data} onExport={DescargarInforme} isLoading={isLoading} />
		</>
	);
};

export default SeleccionInformesContainer;